export default __webpack_public_path__ + "static/media/swipe-icon.1e7df6c0.svg";